<template>
  <div id="recharge-activity">
    <img src="https://o.666visa.cn/static/recharge.jpg">
  </div>
</template>

<script>
export default {
  name: 'recharge-activity',
};
</script>

<style lang="less">
#recharge-activity {
  margin: 20px auto;
  width: 1000px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 10px;
  background-color: white;
  box-sizing: border-box;
  img {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/RechargeActivity.vue